import React from "react";

const Content = ({ children, class_name = "content" }) => (
  <div className={class_name}>{children}</div>
);

export default Content;
